import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PaymentForm from "./PaymentForm";

const PUBLIC_KEY =
  "pk_test_51LGljsFcJDLjVjlxc132Ta2cRRWlk2OVEhvo4kQxu0NHtoWelbVsdaiYPcamnEzvzdyerj3u4HK8op1H2FuPkvNX00I3NVRWVc";

const stripePromise = loadStripe(PUBLIC_KEY);

export const StripeContainer = () => {
  return (
    <Elements stripe={stripePromise}>
      <PaymentForm />
    </Elements>
  );
};
